import { client } from "api";
import { User } from "features/auth/types/user";
import { CreateUserRequest } from "./createUser";

export type UpdateUserRequest = CreateUserRequest & Pick<User, "id">;

export type UpdateUserResponse = User;

export const updateUser = (request: UpdateUserRequest): Promise<UpdateUserResponse> =>
  client.patch<UpdateUserResponse>(`/user/${request.id}`, request).then((res) => res.data);
